import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { FormMode, Client, ClientCarrierRateFile, ClientMaster } from 'src/app/_models/models';
import { AlertService, AlertOptions, AlertTypes, AlertMessage, AlertSeverity } from 'src/app/alert/alert.component';
import { ClientsService } from 'src/app/services/api/clients.service';
import { CarrierRateFilesService } from 'src/app/services/api/carrier-rate-files.service';
import { CarriersService } from 'src/app/services/api/carriers.service';
import { FormControl, FormGroup, NgForm } from '@angular/forms';
import { Router, RouterOutlet } from '@angular/router';
import { DropdownModule } from 'primeng/dropdown';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';
import { SnackbarComponent } from 'src/app/Shared Components/snackbar/snackbar.component';
import { MessagePopupComponent } from 'src/app/Shared Components/message-popup/message-popup.component';
import { CommonService } from 'src/app/services/common.service';
import { ClientMasterService } from 'src/app/services/api/client-master.service';


interface Carrier {
  Id: number;
  Name: string;
  Engine: string;
  AccountNumber: string;
  APIUsername: string;
  APIPassword: string;
  APIAccessKey: string;
  CarrierRateFiles: SelectItem[];
  SelectedRateFile: CarrierRateFile;
}

interface CarrierRateFile {
  Id: number;
  Label: string;
  FileOriginalName: string;
  FileVersion: string;
  FileName: string;
  UploadedOn: Date;
  CarrierId: number;

  CarrierUserAccount: string;
  CarrierAPIUserName: string;
  CarrierAPIPassword: string;
  CarrierAPIKey: string;
}

@Component({
  selector: 'app-client-mater',
  templateUrl: './client-mater.component.html',
  styleUrls: ['./client-mater.component.scss']
})
export class ClientMaterComponent implements OnInit {
  @ViewChild(RouterOutlet) outlet: RouterOutlet;
  @ViewChild('callAPIDialog') callAPIDialog: TemplateRef<any>;
  clients: Client[];
  clientMasters: ClientMaster[];
  clientMaster: ClientMaster;
  clientsCarrierRateFile: [];
  clientsCarrierRateFileData: [];
  //carriers: SelectItem[];
  carriers: SelectItem[] = new Array<SelectItem>();
  rateFile: SelectItem[] = [];
  selectedCity: any;
  selected_carrier: Carrier;
  public tabledata: any[] = [];



  carriersFromAPI: any;
  clientMastersFromAPI: any;

  mode: FormMode = FormMode.None;
  formModes = FormMode;
  //model: Client = new Client();
  model: ClientMaster = new ClientMaster();
  showdiag: boolean = false;
  diagmsg: string;
  selectedCarrier: any;
  selectedRateFile: string;

  frequency: SelectItem[] = [
    { label: "Weekly", value: 1 },
    { label: "BiWeekly", value: 2 },
    { label: "Monthly", value: 3 }
  ];

  mindate: Date = new Date(2013, 1, 1);
  maxdate: Date = new Date(2037, 12, 31);

  clientName: string;
  _carrierRateFilesDiag: boolean;

  public RateFileDtCols = [
    { field: 'Id', header: 'Id' },
    { field: 'Label', header: 'Label' },
    { field: 'FileOriginalName', header: 'Name' },
    { field: 'UploadedOn', header: 'Date' }
  ];

  public ShowMapping: boolean = false;
  public isRateFileButtonDisplay: boolean = false;

  constructor(private carrierService: CarriersService, private clientService: ClientsService
    , private clientMasterService: ClientMasterService
    , private rateFileService: CarrierRateFilesService, private alert: AlertService,
    public dialog: MatDialog, private _snackBar: MatSnackBar, private router: Router, private comm: CommonService) {

    //this.loadListData();
  }

  displayedColumns: string[] = ['Name', 'BillingID', 'BillingContactID', 'BillingDay', 'BillingFrequency', 'LastBilled', '...'];
  CarrierColums: string[] = ['Carrier', 'RateFile', 'Actions'];

  ClientdataSource = new MatTableDataSource<any>();
  ClientPopupdataSource = new MatTableDataSource<any>();


  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  openDialog() {

    let dialogRef = this.dialog.open(this.callAPIDialog);
    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        if (result !== 'no') {
          const enabled = "Y"
          console.log(result);
        } else if (result === 'no') {
          console.log('User clicked no.');
        }
      }
    })
  }
  onSend(form: NgForm) {
    if (form.status === 'INVALID') {
      // display error in your form
    } else {
      console.log(form.value)
      this.dialog.closeAll(); // Close opened diaglo
      // do whatever you want to do with your data
    }

  }

  ngAfterViewInit() {
    this.loadListData();
    this.ClientdataSource.paginator = this.paginator;
    this.ClientPopupdataSource.paginator = this.paginator;
  }

  async loadListData() {

    this.clientMasters = null;

    this.clientService.getAllClientMasters(null).subscribe(
      r => {

        this.clientMasters = new Array<ClientMaster>();

        for (let client of r) {

          client.BillingDay = client.BillingDay;

          this.clientMasters.push(client);
        }
        this.tabledata = this.clientMasters;
        this.ClientdataSource = new MatTableDataSource(this.clientMasters);
        this.ClientdataSource.paginator = this.paginator;

      },
      e => {
        // this.alert.send(AlertMessage.getOnHttpError("ClientGetCarrierList", "Failed to carrier list", e));
        this.openSnackBar('Failed to load Client master list', 'error');

      }
    );
  }

  onChangedPageSize($event) {
    console.log($event);
  }

  ngOnInit() {

  }
  private _filter(value: any): any[] {
    const filterValue = value.toLowerCase();

    return this.carriers.filter(option => option.label.toLowerCase().includes(filterValue));
  }

  onSubmit(form: any) {
    switch (this.mode) {
      case FormMode.Find: {
        this.clientService.getAllClientMasters(this.clientName).subscribe(
          r => {

            this.clientMasters = new Array<ClientMaster>();


            for (let client of r) {

              client.BillingDay = client.BillingDay;

              this.clientMasters.push(client);
            }
            this.tabledata = this.clientMasters;
            this.ClientdataSource = new MatTableDataSource(this.clientMasters);
            this.ClientdataSource.paginator = this.paginator;
            this.ClientPopupdataSource.paginator = this.paginator;
          },
          e => {
            this.openSnackBar('Failed to get carrier master list', 'error');
          }
        );
        break;
      }
      case FormMode.New: {
        if (form.invalid) {

        } else {
          this.post(form);
        }
        break;
      }
      case FormMode.Edit: {
        if (form.invalid) {

        } else {
          this.put(form);
        }
        break;
      }
      case FormMode.Del: {
        this.delete();
        break;
      }
      default: {
        break;
      }
    }
  }

  post(form: any) {
    //debugger;
    var id = this.model.id;

    // var id1 = this.model.clientMasterId;
    this.clientService.createClientMaster(this.model).subscribe(
      r => {
        form.resetForm();
        this.resetForm();
        this.loadListData();
        if (r == null) {
          this.openSnackBar('Client with same name already exists', 'success');
        } else {
          // this.alert.send(new AlertMessage("ClientInsertSuccess", "Saved sucessfully", AlertSeverity.Success, <AlertOptions>{ BoxType: AlertTypes.Toast }));
          this.openSnackBar('Saved sucessfully', 'success');
          //this.router.navigate(['administration/carrier']);
        }
      },
      e => function (ex) {
        // this.alert.send(AlertMessage.getOnHttpError("ClientInsertFail", "Failed to save", e));
        this.openSnackBar('Failed to save', 'error');
      }
    );
  }

  put(form: any) {
    this.clientService.updateClientMaster(this.model).subscribe(result => {
      form.resetForm();
      this.resetForm();
      this.loadListData();
      //this.alert.send(new AlertMessage("ClientUpdateSuccess", "Saved sucessfully", AlertSeverity.Success, <AlertOptions>{ BoxType: AlertTypes.Toast }));
      this.openSnackBar('Updated sucessfully', 'success');

    }, error => {
      //this.alert.send(AlertMessage.getOnHttpError("ClientUpdateFail", "Failed to update", error));
      this.openSnackBar('Failed to update', 'error');

    });
  }

  delete() {
    this.dialog
      .open(MessagePopupComponent, {
        data: {
          title: 'Delete Client',
          confirmText: 'Delete',
          cancelText: 'Cancel',
          message: 'Are you sure you want to DELETE selected Client?',
          // alertcontent: '*you cannot undo the changes',
        },
      })
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          //debugger;
          this.clientService.deleteClientMaster(this.model.id).subscribe(result => {
            this.resetForm();
            this.loadListData();
            //this.alert.send(new AlertMessage("ClientDeleteSuccess", "Deleted sucessfully", AlertSeverity.Success, <AlertOptions>{ BoxType: AlertTypes.Toast }));
            this.openSnackBar('Deleted sucessfully', 'success');

          }, error => {
            //this.alert.send(AlertMessage.getOnHttpError("ClientDeleteFail", "Failed to delete", error));
            this.openSnackBar('Failed to delete', 'error');

          });

        }
      });

  }


  resetForm() {
    this.loadListData();
    this.mode = FormMode.None;
    this.model.selected = false;
    this.model = new ClientMaster();
  }

  showFind() {
    this.mode = FormMode.Find;
    this.model.selected = false;
    this.model = new ClientMaster();
  }

  showNew() {
    //debugger;
    this.mode = FormMode.New;
    this.model.selected = false;
    this.isRateFileButtonDisplay = false;
    this.model = new ClientMaster();
    this.clientMasters = null;
    this.getClientMaster();
  }

  showEdit(p: any) {
    //debugger;
    this.mode = FormMode.Edit;
    this.model.selected = false;
    this.model = p;
    this.model.selected = true;
    localStorage.setItem('clientMasterId', p.id.toString());

    //debugger;
    this.getClientMaster();
  }

  showDel(p: any) {
    this.mode = FormMode.Del;
    this.model.selected = false;
    this.model = p;
    this.model.selected = true;

  }

  getClientMaster() {
    //debugger;
    this.clientMasterService.getAll(null).subscribe(
      r => {
        this.clientMasters = new Array<ClientMaster>();
        this.clientMastersFromAPI = r;
        for (let clientMasterObj of r) {
          let c: ClientMaster = {
            id: clientMasterObj.id,
            name: clientMasterObj.name,
            billingContactID : clientMasterObj.billingContactID,
            billingID: clientMasterObj.billingID,
            billingDay: clientMasterObj.billingDay,
            billingFrequency: clientMasterObj.billingFrequency,
            netTerms: clientMasterObj.netTerms,
            lastBilled: clientMasterObj.lastBilled,

            apiKey: clientMasterObj.apiKey,
            active: clientMasterObj.active,
            selected: false

          };

          this.clientMasters.push({
            name: c.name, apiKey: c.apiKey, id: c.id, active: c.active
            , billingContactID: c.billingContactID, billingDay: c.billingDay
            , billingFrequency: c.billingFrequency, billingID: c.billingID
            , netTerms: c.netTerms, lastBilled: c.lastBilled
            , selected: false
          });
        }
      },
      e => {
        this.openSnackBar('Failed to get Client Master list', 'error');
      }
    );
  }

  showNewMap() {
    this.mode = FormMode.New;
    this.model.selected = false;
  }

  clearFields(CarrierForm) {
    this.mode = FormMode.New;
    CarrierForm.resetForm();

  }

  openSnackBar(message: string, messageType: 'error' | 'success' | 'notification') {
    let config = new MatSnackBarConfig();
    config.data = {
      message: message,
      type: messageType
    };
    config.duration = environment.messageTimeOut;
    config.verticalPosition = 'top';
    config.horizontalPosition = 'center';
    config.panelClass = messageType;
    this._snackBar.openFromComponent(SnackbarComponent, config);
  }

  close() {
    this.dialog.closeAll();
    this.ClientdataSource = new MatTableDataSource(this.tabledata);
    this.ClientdataSource.paginator = this.paginator;
  }

}
